import { useContext, useEffect, useState } from 'react'
import PageWrapper from 'components/PageWrapper'

// Api
import { getCard, setToggleCard } from 'api/credit-card'

import ModalContainer from 'components/ModalContainer'
import PrimaryButton from 'components/primaryButton'
import Table from 'components/table'
import TableItem from 'components/TableItem'
import { tableItemButton } from 'constants/tableItem'
import { useNavigate } from 'react-router-dom'
import LogoutModal from 'components/LogoutModal'

// Contexts
import { MeContext } from 'contexts/me'

// Constants
import WORDING from '../../constants/wording'

const Configuration = () => {
  const [card, setCard] = useState()
  const [loading, setLoading] = useState()
  const [openLogoutModal, setOpenLogoutModal] = useState(false)
  const [openPauseCardModal, setPauseCardModal] = useState(false)
  const {
    ACTIVAR_TARJETA,
    ACTIVAR_TARJETA_MSG,
    PAUSAR_TARJETA,
    CONFIRMAR,
    PAUSAR_TARJETA_MSG
  } = WORDING
  const { me } = useContext(MeContext)
  const navigate = useNavigate()

  async function onPauseCard() {
    setLoading(true)
    await setToggleCard(
      { card_status: card.card_status === 'ACTIVE' ? 'BLOCKED' : 'ACTIVE' },
      card.uuid
    )
    await getData()
    setLoading(false)
    setPauseCardModal(false)
  }

  async function getData() {
    const result = await getCard({ data: me?.user?.uuid, type: 'VIRTUAL' })
    setCard(result.data)
    if (!result.success) {
      setCard(result)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <PageWrapper noTabBar title='Configuración'>
      <section className='md:max-w-564 md:flex md:items-end md:flex-col mx-auto'>
        <Table className='mt-8'>
          <TableItem
            value={
              card?.card_status === 'BLOCKED' ? ACTIVAR_TARJETA : PAUSAR_TARJETA
            }
            buttonType={tableItemButton.ARROW}
            onClick={() => {
              setPauseCardModal(true)
              setOpenLogoutModal(false)
            }}
          />
          <TableItem
            value='Cambiar contraseña'
            buttonType={tableItemButton.ARROW}
            onClick={() => navigate('/recuperar-contrasena')}
          />
          <TableItem
            value='Cerrar sesión'
            buttonType={tableItemButton.ARROW}
            onClick={() => {
              setPauseCardModal(false)
              setOpenLogoutModal(true)
            }}
          />
        </Table>

        {/* pause credit card modal */}
        <ModalContainer
          title={
            card?.card_status === 'BLOCKED' ? ACTIVAR_TARJETA : PAUSAR_TARJETA
          }
          isShown={openPauseCardModal}
          setModalFunction={setPauseCardModal}
        >
          <p className='text-center'>
            {card?.card_status === 'BLOCKED'
              ? ACTIVAR_TARJETA_MSG
              : PAUSAR_TARJETA_MSG}
          </p>
          <div className='border-t border-solid border-gray-500 mb-6 mt-3' />
          <div className='flex mt-auto justify-between gap-12'>
            <PrimaryButton
              buttonText='Cancelar'
              primaryButtonFunction={() => setPauseCardModal(false)}
              outlined
            />
            <PrimaryButton
              buttonText={CONFIRMAR}
              isLoading={loading}
              primaryButtonFunction={() => onPauseCard()}
            />
          </div>
        </ModalContainer>
        {/* logout */}
        <LogoutModal isOpen={openLogoutModal} setIsOpen={setOpenLogoutModal} />
      </section>
    </PageWrapper>
  )
}

export default Configuration
